import { render, staticRenderFns } from "./DeliveryChart.vue?vue&type=template&id=585e8741&"
import script from "./DeliveryChart.vue?vue&type=script&lang=js&"
export * from "./DeliveryChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports